import { toUrlParams } from '../base/url'
import { jump2TemplateMethod } from './base'
import { WX_PATH_PREFIX } from './mp-const'

interface I_PARAMS {
  userId: string | number
  [x: string]: string | number
}

export function getIPath({ userId, ...extras }: I_PARAMS): string {
  const queryString = toUrlParams(extras)
  return `/profile/${userId}${queryString ? `?${queryString}` : ''}`
}

/**
 * [$jump2profile 跳转到个人主页]
 */
export default function jump2profile({ userId, ...extras }: I_PARAMS) {
  const queryString = toUrlParams(extras)
  const iPath = `/profile/${userId}${queryString ? `?${queryString}` : ''}`
  const mpDynamicPage = `/dynamic-page/index?hostId=${userId}&${queryString}&case=subpackage-profile-profile`

  jump2TemplateMethod({
    iPath,
    mpPathMap: {
      dianping_wxapp: `${WX_PATH_PREFIX.dianpingSub}${mpDynamicPage}`,
      group_wxapp: `${WX_PATH_PREFIX.meituan}${mpDynamicPage}`,
      hotel_wxapp: `${WX_PATH_PREFIX.hotelSub}${mpDynamicPage}|zhenguo`,
      phoenix_wxapp: `${WX_PATH_PREFIX.phx}/host/host?hostId=${userId}&${queryString}`,
    },
    rnPathConfig: {
      versions: { phx: '3.5.0', meituan: '9.13.400', dianping: '10.13.0' },
      mrn_entry: 'host-profile',
      mrn_component: 'zhenguo-host-profile',
      mrn_translucent: true,
      params: {
        hostId: userId,
        ...extras,
      },
    },
  })
}
